/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { TweetImage } from '../models/tweet-image';
@Injectable({
  providedIn: 'root',
})
class PoliticianTweetService extends __BaseService {
  static readonly uploadTwitterTweetPath = '/politicianTradesTweet';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param tweet Image upload tweet
   */
  uploadTwitterTweetResponse(tweetImage?: TweetImage): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = tweetImage;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/politicianTradesTweet`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param tweet Image upload tweet
   */
  uploadTwitterTweet(tweetImage?: TweetImage): __Observable<null> {
    return this.uploadTwitterTweetResponse(tweetImage).pipe(
      __map(_r => _r.body as null)
    );
  }
}

module PoliticianTweetService {
}

export { PoliticianTweetService }
